import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import { TimeMap } from '../../elements-date-time/data/time-data';

const translationMessages = defineMessages({
  startTime: {
    id: 'hosting.select_time_field_hoc.start_time',
    defaultMessage: 'start time'
  },
  endTime: {
    id: 'hosting.select_time_field_hoc.end_time',
    defaultMessage: 'end time'
  }
});

const SelectTimeFieldHOC = (intl, WrappedComponent) => {
  class HOC extends React.Component {
    timeOptions () {
      // we only want the time range of 5pm - 4am
      const startTimes = _.filter(TimeMap, (v, k) => (22 <= k && 44 >= k));
      return startTimes.map(timeObj => {
        const { time_index: timeIndex, time } = timeObj;
        return {
          value: timeIndex,
          label: <div>{intl.formatTime(moment(time, 'LT').format())}</div>
        };
      });
    }

    render () {
      const placeholder = intl.formatMessage(translationMessages.endTime);

      return (
        <WrappedComponent
          placeholder={placeholder}
          options={this.timeOptions()}
          {...this.props}
        />
      );
    }
  }
  HOC.propTypes = {
    isStartTime: PropTypes.bool,
    startTimeIndex: PropTypes.number
  };
  return HOC;
};

export default SelectTimeFieldHOC;
